export const handleAPIRequest = async (url: string) => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const data = await response.json() // JSON 응답을 가정
    console.log(data) // 처리 결과 확인
  } catch (error) {
    console.error('Failed to fetch data:', error)
  }
}
